module.exports = __webpack_public_path__ + "static/media/syncWhatsapp_step2_en.ed840961.jpg";